import AgencyCampaignsDashboard from './components/AgencyCampaignsDashboard';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import values from 'lodash/values';

import './assets/AgencyCampaignsDashboard.css';

import {
  resumeCampaign,
  suspendCampaign,
  deleteCampaign,
  revertCampaignToDraft,
  archiveCampaign,
  duplicateCampaign,
  extendCampaign
} from '../../shared/redux/entities/actions'

import { getActiveAgencyUser } from '../../shared/redux/selectors';

import { alphabeticallySort } from '../../shared/utils';

function getBrandsForAgency(state,agencyId){
  return values(get(state,['entities','companies'],{}))
    .filter((c) => c.isBrand && c.agencyId === agencyId)
    .sort((a,b) => alphabeticallySort(a.name,b.name));
}

function getBrandKPIsForBrandIds(state,brandIds){
  return values(get(state,['kpis','brands']))
    .filter((kpi) => kpi.connectionCount > 0)
    .filter((kpi) => brandIds.indexOf(kpi.brandId) >=0)
}

function getCampaignKPIsforCampaignIds(state,campaignIds){
  return values(get(state,['kpis','campaigns']))
    .filter((kpi) => campaignIds.indexOf(kpi.campaignId) >=0)
}


function mapStateToProps(state,props){
  const user = getActiveAgencyUser(state),
    campaigns = values(get(state,['entities','campaigns'],{})).filter((c) => c.agencyId === user.agencyId),
    campaignKPIs = values(get(state,['kpis','campaigns'])),
    anyLiveCampaigns = campaigns.some((c) => ['active','complete','suspended','outOfFunds'].indexOf(c.status) >= 0),
    introRunning = state.intro.started && !state.intro.completed,
    isDemo = values(get(state,['kpis','campaigns'])).some((c) => !!c.demoStatus),
    brands = getBrandsForAgency(state, user.agencyId),
    brandIds = brands.map((b) => b.id),
    campaignIds = campaigns.map((c) => c.id);

  return {
    campaigns:campaigns,
    brands:getBrandsForAgency(state, user.agencyId),
    brandKPIs:getBrandKPIsForBrandIds(state,brandIds),
    campaignKPIs:getCampaignKPIsforCampaignIds(state,campaignIds),
    user:user,
    shouldGrayOutStats:!anyLiveCampaigns && !introRunning && !isDemo,
    shouldUsePlaceholderDataForList:introRunning,
    shouldUsePlaceholderDataForStats:!anyLiveCampaigns && !isDemo,
    shouldForceOpenBrandPicker:!state.intro.completed && (state.intro.currentStep === 2 || state.intro.currentStep === 3)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    resumeCampaign,
    suspendCampaign,
    deleteCampaign,
    revertCampaignToDraft,
    archiveCampaign,
    duplicateCampaign,
    extendCampaign
  },dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(AgencyCampaignsDashboard);



// WEBPACK FOOTER //
// ./src/routes/AgencyCampaignsDashboard/index.js